/* Vibes HUD layer for the Thunder theme (22 Oct 2026). Ported from the HUD Lab prototype.
   No dependencies. Every module keys off a data-hud-* attribute, so a section only gets
   the behaviour it renders markup for. Motion respects prefers-reduced-motion. */
(() => {
  if (window.__vibesHud) return; window.__vibesHud = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/#·';
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const json = (el) => { try { return JSON.parse(el.textContent); } catch (e) { return null; } };
  const io = (els, fn, threshold = .35) => {
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(fn); return; }
    const o = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { fn(e.target); o.unobserve(e.target); } }), { threshold });
    els.forEach(el => o.observe(el));
  };

  /* ---------- 1. Split-flap announcement bar ---------- */
  $$('[data-hud-flap]').forEach(flap => {
    let msgs = []; try { msgs = JSON.parse(flap.dataset.hudFlap); } catch (e) {}
    msgs = msgs.map(m => String(m).toUpperCase()).filter(Boolean);
    if (!msgs.length) return;
    const len = Math.max(...msgs.map(m => m.length));
    const cells = [];
    for (let i = 0; i < len; i++) { const c = document.createElement('span'); c.className = 'ch sp'; c.setAttribute('aria-hidden', 'true'); flap.appendChild(c); cells.push(c); }
    const live = document.createElement('span'); live.className = 'sr'; live.setAttribute('aria-live', 'polite'); flap.parentNode.appendChild(live);
    const setCell = (c, ch) => { c.textContent = ch === ' ' ? '' : ch; c.classList.toggle('sp', ch === ' '); };
    const show = (msg) => {
      live.textContent = msg;
      const lead = Math.floor((len - msg.length) / 2), target = (' '.repeat(lead) + msg).padEnd(len, ' ');
      cells.forEach((c, i) => {
        const final = target[i];
        if (reduced) { setCell(c, final); return; }
        let n = 3 + Math.floor(Math.random() * 6);
        const tick = () => {
          if (n-- <= 0 || final === ' ') { setCell(c, final); return; }
          setCell(c, GLYPHS[Math.floor(Math.random() * GLYPHS.length)]);
          c.classList.remove('flip'); void c.offsetWidth; c.classList.add('flip');
          setTimeout(tick, 55);
        };
        setTimeout(tick, i * 18);
      });
    };
    let idx = 0; show(msgs[0]);
    if (msgs.length > 1) setInterval(() => { idx = (idx + 1) % msgs.length; show(msgs[idx]); }, 4200);
  });

  /* ---------- 2. Visitor coordinates (time zone → nearest major city, no location prompt) ---------- */
  const TZ = {
    'Europe/Rome':['ROM',41.90,12.50],'Europe/Berlin':['BER',52.52,13.40],'Europe/London':['LON',51.51,-0.13],'Europe/Paris':['PAR',48.86,2.35],
    'Europe/Madrid':['MAD',40.42,-3.70],'Europe/Amsterdam':['AMS',52.37,4.90],'Europe/Brussels':['BRU',50.85,4.35],'Europe/Zurich':['ZRH',47.37,8.54],
    'Europe/Vienna':['VIE',48.21,16.37],'Europe/Copenhagen':['CPH',55.68,12.57],'Europe/Stockholm':['STO',59.33,18.07],'Europe/Oslo':['OSL',59.91,10.75],
    'Europe/Helsinki':['HEL',60.17,24.94],'Europe/Dublin':['DUB',53.35,-6.26],'Europe/Lisbon':['LIS',38.72,-9.14],'Europe/Warsaw':['WAW',52.23,21.01],
    'Europe/Prague':['PRG',50.08,14.44],'Europe/Athens':['ATH',37.98,23.73],'Europe/Istanbul':['IST',41.01,28.98],'Europe/Budapest':['BUD',47.50,19.04],
    'America/New_York':['NYC',40.71,-74.01],'America/Chicago':['CHI',41.88,-87.63],'America/Denver':['DEN',39.74,-104.99],'America/Phoenix':['PHX',33.45,-112.07],
    'America/Los_Angeles':['LAX',34.05,-118.24],'America/Toronto':['TOR',43.65,-79.38],'America/Vancouver':['VAN',49.28,-123.12],'America/Mexico_City':['MEX',19.43,-99.13],
    'America/Sao_Paulo':['SAO',-23.55,-46.63],'America/Anchorage':['ANC',61.22,-149.90],'Pacific/Honolulu':['HNL',21.31,-157.86],
    'Australia/Sydney':['SYD',-33.87,151.21],'Australia/Melbourne':['MEL',-37.81,144.96],'Australia/Brisbane':['BNE',-27.47,153.03],'Australia/Perth':['PER',-31.95,115.86],
    'Australia/Adelaide':['ADL',-34.93,138.60],'Pacific/Auckland':['AKL',-36.85,174.76],'Asia/Tokyo':['TYO',35.68,139.69],'Asia/Seoul':['SEL',37.57,126.98],
    'Asia/Shanghai':['SHA',31.23,121.47],'Asia/Hong_Kong':['HKG',22.32,114.17],'Asia/Singapore':['SIN',1.35,103.82],'Asia/Kuala_Lumpur':['KUL',3.14,101.69],
    'Asia/Bangkok':['BKK',13.76,100.50],'Asia/Jakarta':['JKT',-6.21,106.85],'Asia/Manila':['MNL',14.60,120.98],'Asia/Kolkata':['DEL',28.61,77.21],
    'Asia/Dubai':['DXB',25.20,55.27],'Asia/Riyadh':['RUH',24.71,46.68],'Africa/Johannesburg':['JNB',-26.20,28.05],'Africa/Cairo':['CAI',30.04,31.24]
  };
  $$('[data-hud-coords]').forEach(el => {
    let tz = ''; try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
    const hit = TZ[tz], f = (v, p, n) => Math.abs(v).toFixed(2) + '°' + (v >= 0 ? p : n);
    el.innerHTML = '<span class="dot" aria-hidden="true"></span>' + (hit
      ? '<span class="city">' + hit[0] + ' </span><b class="num">' + f(hit[1], 'N', 'S') + ' ' + f(hit[2], 'E', 'W') + '</b>'
      : '<b>' + (tz.split('/').pop() || 'Worldwide').replace(/_/g, ' ').toUpperCase() + '</b>');
    el.title = 'Your approximate location, from your time zone';
  });

  /* ---------- 2b. Phones: the header Cart opens the full cart page (express checkout lives there) ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('#cart-icon-bubble');
    if (!a || !window.matchMedia('(max-width: 749px)').matches) return;
    if (document.getElementById('main-cart-items')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }, true);

  /* ---------- 3. Decode on the blue/lime accent words only ---------- */
  const decode = (el) => {
    if (reduced || el.dataset.decoded) return;
    el.dataset.decoded = '1';
    const finalText = el.textContent, dur = +el.dataset.decode || 900, start = performance.now();
    const step = (t) => {
      const p = Math.min(1, (t - start) / dur), keep = Math.floor(finalText.length * p);
      let out = finalText.slice(0, keep);
      for (let i = keep; i < finalText.length; i++) out += /\s/.test(finalText[i]) ? finalText[i] : GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
      el.textContent = out;
      if (p < 1) requestAnimationFrame(step); else el.textContent = finalText;
    };
    requestAnimationFrame(step);
  };
  io($$('[data-decode]'), decode, .4);

  /* ---------- 4. Readouts, callouts: animate in when in view ---------- */
  io($$('[data-hud-live]'), el => el.classList.add('live'), .35);

  /* ---------- 5. Info pop-ups (CAT, polarized PC / TAC, UV400) ---------- */
  const ip = document.querySelector('[data-hud-info-pop]');
  const curCat = () => { const c = document.querySelector('[data-hud-cat]'); return c ? c.textContent.trim() : '3'; };
  if (ip) {
    const catText = (n) => {
      const rows = [['0', '80–100%', 'Fashion or indoor tint'], ['1', '43–80%', 'Light sun'], ['2', '18–43%', 'Medium sun, everyday city'], ['3', '8–18%', 'Bright sun, beach, water'], ['4', '3–8%', 'Extreme sun, glacier. Not for driving']];
      return '<p>The category (CAT) rates how much visible light a lens lets through, under the sunglass standards (EN ISO 12312-1 / ANSI Z80.3 / AS/NZS 1067.1). The higher the number, the darker the lens.</p>' +
        '<div class="ip-table">' + rows.map(r => '<div class="' + (r[0] === String(n) ? 'on' : '') + '"><b>CAT ' + r[0] + '</b><span class="num">' + r[1] + '</span><span>' + r[2] + '</span></div>').join('') + '</div>' +
        '<p>This colourway is <b>CAT ' + n + '</b>. ' + (n == 3 ? 'Made for bright sun. Not suitable for night driving.' : n == 2 ? 'A lighter lens for everyday and city light. Not suitable for night driving.' : '') + '</p>';
    };
    const INFO = {
      cat: () => ['Light transmission: CAT', catText(curCat())],
      pc:  () => ['Polarized PC lens', '<p><b>PC (polycarbonate)</b> is a light, impact-resistant lens material.</p><p><b>Polarized</b> means a filter in the lens blocks glare that bounces off flat surfaces like water, wet roads, car bonnets and glass, so you see contrast instead of a white haze.</p><p>Tip: polarized lenses can make some phone and car screens look darker at certain angles. That is normal.</p>'],
      tac: () => ['Polarized TAC lens', '<p><b>TAC (tri-acetate cellulose)</b> lenses are built in thin layers around a polarizing film, which keeps them light and optically clear.</p><p><b>Polarized</b> means that film blocks glare that bounces off flat surfaces like water, wet roads and glass, so you see contrast instead of a white haze.</p><p>Tip: polarized lenses can make some phone and car screens look darker at certain angles. That is normal.</p>'],
      uv:  () => ['UV400', '<p>UV400 lenses block ultraviolet light up to 400 nanometres, which covers both UVA and UVB rays.</p><p>That protection is separate from how dark the lens looks: a light CAT 2 lens still blocks UVA and UVB.</p>']
    };
    let anchor = null;
    const place = () => {
      if (!anchor || ip.hidden) return;
      if (innerWidth < 720) { ip.style.left = ''; ip.style.top = ''; ip.classList.add('sheet'); return; }
      ip.classList.remove('sheet');
      const r = anchor.getBoundingClientRect(), w = ip.offsetWidth, h = ip.offsetHeight;
      const left = Math.min(innerWidth - w - 16, Math.max(16, r.left + r.width / 2 - w / 2));
      let top = r.bottom + 10; if (top + h > innerHeight - 16) top = Math.max(16, r.top - h - 10);
      ip.style.left = left + 'px'; ip.style.top = top + 'px';
    };
    const closeI = () => { ip.hidden = true; if (anchor) anchor.setAttribute('aria-expanded', 'false'); anchor = null; };
    document.addEventListener('click', e => {
      const b = e.target.closest('[data-hud-info]');
      if (b) {
        e.preventDefault(); e.stopPropagation();
        if (anchor === b) { closeI(); return; }
        const fn = INFO[b.dataset.hudInfo]; if (!fn) return;
        const [t, body] = fn();
        ip.querySelector('[data-hud-info-title]').textContent = t; ip.querySelector('[data-hud-info-body]').innerHTML = body;
        if (anchor) anchor.setAttribute('aria-expanded', 'false');
        anchor = b; b.setAttribute('aria-expanded', 'true'); ip.hidden = false; place();
        return;
      }
      if (!ip.hidden && !e.target.closest('[data-hud-info-pop]')) closeI();
    });
    ip.querySelector('[data-hud-info-close]').addEventListener('click', closeI);
    addEventListener('keydown', e => { if (e.key === 'Escape') closeI(); });
    addEventListener('scroll', place, { passive: true }); addEventListener('resize', place);

    /* ⓘ next to the lens and UV400 lines inside the product page's Technical Specs text */
    const specHook = document.querySelector('[data-hud-spec-scan]');
    const specRoot = specHook && (specHook.closest('.shopify-section') || specHook);
    if (specRoot) {
      const KEYS = [[/TAC Polari[sz]ed/i, 'tac', 'What is polarized TAC?'], [/Polari[sz]ed PC/i, 'pc', 'What is polarized PC?'], [/UV400/i, 'uv', 'What is UV400?']];
      const done = new Set();
      const walker = document.createTreeWalker(specRoot, NodeFilter.SHOW_TEXT);
      const hits = [];
      while (walker.nextNode()) {
        const n = walker.currentNode;
        if (n.parentElement.closest('.hud, script, style, button')) continue;
        if (!n.parentElement.closest('details, [class*="accordion"], [class*="dropdown"], [class*="collapsible"]')) continue;
        KEYS.forEach(([re, key, label]) => { if (!done.has(key) && re.test(n.textContent)) { done.add(key); hits.push([n, key, label]); } });
      }
      hits.forEach(([n, key, label]) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'hud-info-inline'; b.dataset.hudInfo = key; b.setAttribute('aria-label', label); b.textContent = 'i';
        const line = n.textContent, m = line.match(/UV400|TAC Polari[sz]ed|Polari[sz]ed PC/i);
        // place the button right after the matched words where possible
        const after = n.splitText(Math.min(line.length, m.index + m[0].length));
        n.parentNode.insertBefore(b, after);
      });
    }
  }

  /* ---------- 6. Variant sync: CAT, callout image, readout light row ---------- */
  const vdata = document.querySelector('[data-hud-variants]');
  if (vdata) {
    const V = json(vdata) || {};
    const apply = (id) => {
      const v = V[id]; if (!v) return;
      $$('[data-hud-cat]').forEach(el => el.textContent = v.cat);
      $$('[data-hud-cat-copy]').forEach(el => el.textContent = v.cat == 2 ? 'For everyday city light' : 'For bright sun');
      $$('[data-hud-cat-bar]').forEach(el => el.style.setProperty('--w', (v.cat / 4 * 100) + '%'));
      if (v.front) $$('[data-hud-callout-img]').forEach(img => { img.src = v.front; img.removeAttribute('srcset'); });
      $$('[data-hud-shape]').forEach(el => { if (v.shape) el.textContent = v.shape; });
    };
    const read = () => {
      const u = new URL(location.href).searchParams.get('variant');
      const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      return u || (input && input.value);
    };
    let last = read(); apply(last);
    const check = () => { const id = read(); if (id && id !== last) { last = id; apply(id); } };
    document.addEventListener('change', () => setTimeout(check, 60));
    document.addEventListener('click', () => setTimeout(check, 120));
    addEventListener('popstate', check);
    if (window.subscribe && window.PUB_SUB_EVENTS) try { subscribe(PUB_SUB_EVENTS.variantChange, e => { const id = e && e.data && e.data.variant && e.data.variant.id; if (id) { last = String(id); apply(last); } }); } catch (e) {}
  }

  /* ---------- 7. Fit check on the urban fit readout ---------- */
  $$('[data-hud-fit-check]').forEach(fc => {
    const out = fc.querySelector('[data-hud-fit-out]'), ref = parseFloat(fc.dataset.hudFitCheck), name = fc.dataset.name;
    fc.addEventListener('submit', e => {
      e.preventDefault();
      const w = parseFloat(fc.querySelector('input').value);
      if (!(w >= 40 && w <= 75)) { out.textContent = 'Enter a lens width between 40 and 75 mm.'; return; }
      const d = +(ref - w).toFixed(1);
      out.textContent = Math.abs(d) <= 1 ? name + ' fits like your pair (' + (d > 0 ? '+' : '') + d + ' mm per lens).'
        : name + ' is ' + Math.abs(d) + ' mm ' + (d > 0 ? 'wider' : 'narrower') + ' per lens than your pair.';
    });
  });

  /* ---------- 8. Series collections: chips filter, count, empty state, in-grid feature ---------- */
  const fbar = document.querySelector('[data-hud-filters]');
  const gridCards = () => $$('.collection-product-card[data-hud]');
  if (fbar) {
    const countEl = fbar.querySelector('[data-hud-count]'), unit = fbar.dataset.unit || 'STYLES';
    const f = {};
    const setCount = (n) => {
      if (!countEl) return;
      const t = String(n).padStart(2, '0') + ' ' + unit;
      if (reduced) { countEl.textContent = t; return; }
      let k = 0; const iv = setInterval(() => { countEl.textContent = [...t].map((ch, i) => i < k || ch === ' ' ? ch : GLYPHS[Math.floor(Math.random() * GLYPHS.length)]).join(''); if (++k > t.length) { clearInterval(iv); countEl.textContent = t; } }, 35);
    };
    const apply = () => {
      let n = 0;
      gridCards().forEach(c => {
        const on = Object.entries(f).every(([g, v]) => v === 'all' || (' ' + (c.dataset['hud' + g[0].toUpperCase() + g.slice(1)] || '') + ' ').includes(' ' + v + ' '));
        c.hidden = !on; if (on) n++;
      });
      const feat = document.querySelector('[data-hud-feature-li]');
      if (feat) feat.hidden = Object.values(f).some(v => v !== 'all') && !(feat.dataset.matches || '').split(' ').some(m => Object.values(f).includes(m));
      const empty = document.querySelector('[data-hud-empty]'); if (empty) empty.hidden = n > 0;
      setCount(n);
    };
    $$('[data-hud-chip]', fbar).forEach(b => { const g = b.dataset.group; if (!(g in f)) f[g] = 'all'; b.addEventListener('click', () => {
      f[g] = b.dataset.value; $$('[data-hud-chip][data-group="' + g + '"]', fbar).forEach(x => x.setAttribute('aria-pressed', x === b)); apply();
    }); });
    $$('[data-hud-reset]').forEach(b => b.addEventListener('click', () => { Object.keys(f).forEach(g => f[g] = 'all'); $$('[data-hud-chip]', fbar).forEach(x => x.setAttribute('aria-pressed', x.dataset.value === 'all')); apply(); }));
    setCount(gridCards().length);
  }
  $$('[data-hud-feature]').forEach(tpl => {
    const cards = gridCards().length ? gridCards() : $$('.collection-product-card');
    const n = +tpl.dataset.after || 4; if (!cards[n - 1]) return;
    const li = document.createElement('li'); li.className = 'hud hud-feature-li'; li.dataset.hudFeatureLi = ''; li.dataset.matches = tpl.dataset.matches || '';
    li.appendChild(tpl.content.cloneNode(true)); cards[n - 1].after(li);
  });

  /* ---------- 9. Size match (urban: lens width + bridge; sport: total front width) ---------- */
  $$('[data-hud-size-match]').forEach(sm => {
    const data = json(sm.querySelector('[data-hud-size-data]')) || [], out = sm.querySelector('[data-hud-sm-out]'), mode = sm.dataset.mode;
    const item = (fr, line, d) => '<a class="sm-item" href="' + fr.url + '"><img src="' + fr.img + '" alt="" loading="lazy" width="72" height="72"><span><b>' + fr.name + '</b><span class="num">' + line + '</span><span class="num delta">' + (d > 0 ? '+' : '') + d + ' mm' + (mode === 'total' ? '' : ' lens') + '</span></span></a>';
    sm.addEventListener('submit', e => {
      e.preventDefault();
      if (mode === 'total') {
        const t = parseFloat(sm.querySelector('[name=tw]').value);
        if (!(t >= 110 && t <= 170)) { out.innerHTML = '<p class="sm-msg">Enter the front width in mm, between 110 and 170.</p>'; return; }
        const best = data.filter(x => x.total).sort((a, b) => Math.abs(a.total - t) - Math.abs(b.total - t)).slice(0, 3);
        out.innerHTML = '<p class="sm-msg">Closest to ' + t + ' mm across the front</p><div class="sm-res">' + best.map(x => item(x, x.total + ' mm · ' + x.type, (x.total - t).toFixed(1))).join('') + '</div>';
        return;
      }
      const w = parseFloat(sm.querySelector('[name=lw]').value), b = parseFloat(sm.querySelector('[name=br]').value);
      if (!(w >= 40 && w <= 75)) { out.innerHTML = '<p class="sm-msg">Enter the first number printed inside the temple, between 40 and 75.</p>'; return; }
      const score = x => Math.abs(x.lensW - w) + (b >= 10 && b <= 30 && x.bridge ? .5 * Math.abs(x.bridge - b) : 0);
      const best = data.filter(x => x.lensW && x.lensW < 80).sort((x, y) => score(x) - score(y)).slice(0, 3);
      out.innerHTML = '<p class="sm-msg">Closest to ' + w + (b ? ' □ ' + b : '') + ' mm</p><div class="sm-res">' + best.map(x => item(x, x.lensW + ' □ ' + (x.bridge || '–') + ' · ' + (x.temple || '–'), (x.lensW - w).toFixed(1))).join('') + '</div>';
    });
  });

  /* ---------- 10. Sport compare (up to 3) ---------- */
  const tray = document.querySelector('[data-hud-cmp-tray]');
  if (tray) {
    const panel = document.querySelector('[data-hud-cmp-panel]'), scrim = document.querySelector('[data-hud-cmp-scrim]');
    const D = (k) => { const c = document.querySelector('.collection-product-card[data-hud-key="' + k + '"]'); try { return JSON.parse(c.dataset.hud); } catch (e) { return null; } };
    let picked = [];
    const paint = () => {
      tray.hidden = !picked.length;
      tray.querySelector('[data-hud-cmp-thumbs]').innerHTML = picked.map(k => { const d = D(k); return d ? '<img src="' + d.img + '" alt="' + d.name + '">' : ''; }).join('') + '<span class="slot">' + (picked.length < 3 ? 'Add up to ' + (3 - picked.length) + ' more' : 'Max 3') + '</span>';
      const go = tray.querySelector('[data-hud-cmp-go]'); go.textContent = 'Compare (' + picked.length + ')'; go.disabled = picked.length < 2;
      $$('[data-hud-compare]').forEach(b => b.setAttribute('aria-pressed', picked.includes(b.dataset.hudCompare)));
    };
    document.addEventListener('click', e => {
      const b = e.target.closest('[data-hud-compare]'); if (!b) return;
      e.preventDefault();
      const k = b.dataset.hudCompare;
      if (picked.includes(k)) picked = picked.filter(x => x !== k); else if (picked.length < 3) picked.push(k);
      paint();
    });
    tray.querySelector('[data-hud-cmp-clear]').addEventListener('click', () => { picked = []; paint(); });
    const bar = (v, max, unit) => v ? '<div class="cbar"><i style="width:' + (v / max * 100).toFixed(1) + '%"></i></div><span class="num">' + v + ' ' + unit + '</span>' : '–';
    const openP = () => {
      const ds = picked.map(D).filter(Boolean);
      const maxH = Math.max(...ds.map(d => d.lensH || 0)), maxW = Math.max(...ds.map(d => d.weight || 0));
      const rows = [['Type', d => d.type], ['Lens height', d => bar(d.lensH, maxH, 'mm')], ['Weight', d => bar(d.weight, maxW, 'g')], ['Frame', d => d.frame], ['Lens', d => d.lens],
        ['Light transmission', d => d.cat ? 'CAT ' + d.cat : '–'], ['UV', () => 'UV400 · blocks UVA + UVB'], ['Fit', d => d.fit || 'Unisex'], ['Built for', d => d.use || '–'], ['Price', d => d.price]];
      panel.querySelector('[data-hud-cmp-table]').innerHTML =
        '<div class="ct-row ct-head" style="--n:' + ds.length + '"><span></span>' + ds.map(d => '<div class="ct-prod"><img src="' + d.img + '" alt=""><b>' + d.name + '</b><span class="label">' + d.variant + '</span></div>').join('') + '</div>' +
        rows.map(([l, fn]) => '<div class="ct-row" style="--n:' + ds.length + '"><span class="label">' + l + '</span>' + ds.map(d => '<div>' + fn(d) + '</div>').join('') + '</div>').join('') +
        '<div class="ct-row" style="--n:' + ds.length + '"><span></span>' + ds.map(d => '<div><a class="btn blue" href="' + d.url + '">View</a></div>').join('') + '</div>';
      panel.classList.add('open'); scrim.classList.add('on');
    };
    const closeP = () => { panel.classList.remove('open'); scrim.classList.remove('on'); };
    tray.querySelector('[data-hud-cmp-go]').addEventListener('click', openP);
    panel.querySelector('[data-hud-cmp-close]').addEventListener('click', closeP);
    scrim.addEventListener('click', closeP);
    addEventListener('keydown', e => { if (e.key === 'Escape') closeP(); });
    paint();
  }

  /* ---------- 11. Shipping region modal (one region, fixed currency) ---------- */
  const rm = document.querySelector('[data-hud-region-modal]');
  if (rm) {
    const scrim = document.querySelector('[data-hud-region-scrim]'), sel = rm.querySelector('[data-hud-region-select]'), cur = rm.querySelector('[data-hud-region-currency]'), code = rm.querySelector('[name="country_code"]');
    const sync = () => { const o = sel.selectedOptions[0]; cur.value = o.dataset.currency; code.value = o.dataset.country; };
    const openR = () => { sync(); rm.hidden = false; scrim.classList.add('on'); sel.focus(); };
    const closeR = () => { rm.hidden = true; scrim.classList.remove('on'); };
    sel.addEventListener('change', sync);
    document.addEventListener('click', e => { if (e.target.closest('[data-hud-region-open]')) { e.preventDefault(); openR(); } });
    rm.querySelector('[data-hud-region-close]').addEventListener('click', closeR);
    scrim.addEventListener('click', closeR);
    addEventListener('keydown', e => { if (e.key === 'Escape' && !rm.hidden) closeR(); });
  }
})();

/* ---------- 12. Recently viewed (home: "You Were Viewing These.") ---------- */
(() => {
  const KEY = 'vibes-hud-viewed';
  const get = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
  const set = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} };
  const m = location.pathname.match(/\/products\/([^/?#]+)/);
  if (m) {
    const variant = new URL(location.href).searchParams.get('variant') || '';
    const list = get().filter(x => x.h !== m[1]); list.unshift({ h: m[1], v: variant }); set(list.slice(0, 12));
  }
  const sec = document.querySelector('[data-hud-viewed]'); if (!sec) return;
  const track = sec.querySelector('[data-hud-viewed-track]'), limit = +sec.dataset.limit || 8;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  const cardHtml = (h, v) => fetch(root + 'products/' + h + '?sections=hud-card' + (v ? '&variant=' + v : ''))
    .then(r => r.ok ? r.json() : null).then(j => { if (!j || !j['hud-card']) return ''; const d = document.createElement('div'); d.innerHTML = j['hud-card']; const c = d.querySelector('.vibes-card'); return c ? c.outerHTML : ''; }).catch(() => '');
  const here = m ? m[1] : null;
  const items = get().filter(x => x.h !== here).slice(0, limit);
  const render = (cards, demo) => {
    const html = cards.filter(Boolean).join('');
    if (!html) return;
    track.innerHTML = html; sec.hidden = false;
    const note = sec.querySelector('[data-hud-viewed-note]'); if (note) note.hidden = !demo;
  };
  if (items.length) {
    Promise.all(items.map(x => cardHtml(x.h, x.v))).then(c => render(c, false));
  } else {
    fetch(root + 'collections/' + sec.dataset.fallback + '/products.json?limit=' + Math.min(limit, 8)).then(r => r.ok ? r.json() : { products: [] })
      .then(d => Promise.all((d.products || []).filter(p => p.handle !== here).map(p => cardHtml(p.handle)))).then(c => render(c, true)).catch(() => {});
  }
})();
